// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-calculation/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springCalculationEN: PageEntry = {
  id: "post.federberechnung",
  locale: "en",
  slug: "spring-calculation",
  seo: {
    title: "Glossary: Spring calculation explained simply | Dietz GmbH",
    description: "Spring calculation refers to the process of mathematically analysing and determining the mechanical properties of a spring. Engineers use various formulas and models to calculate p",
  },
  type: "post",
  h1: "Glossary: Spring calculation explained simply",
  intro: "Spring calculation refers to the process of mathematically analysing and determining the mechanical properties of a spring. Engineers use various formulas and models to calculate parameters such as spring constant, maximum deformation, load and free length. Accurate spring calculation is crucial to ensure that the spring performs optimally in a given application. This process takes into account the laws of physics, material characteristics and the specific requirements of the system in which the spring will be used.",
  blocks: [

  ],
};
